var render = function render(){var _vm=this,_c=_vm._self._c;return _c('appointment-historical',{attrs:{"main-page-title":"Manejo de Citas","main-page-routes":['Inicio', 'Estudiante', 'Citas', 'Historial de Citas'],"get-appointment-history":_vm.getAppointmentHistory}})
}
var staticRenderFns = []

export { render, staticRenderFns }